import React, { createContext, useCallback, useState, useMemo } from "react";
import Toast, { ToastMessage } from "../components/Toast";
import { Values } from "@oursky/react-messageformat";

const TOAST_DURATION = 2000;
export interface ToastContextValue {
  presentToast: (
    message: ToastMessage,
    isError?: boolean,
    values?: Values
  ) => void;
}

export const ToastContext = createContext<ToastContextValue>({
  presentToast: () => {},
});

interface ToastState {
  isPresenting: boolean;
  message: ToastMessage | null;
  isError: boolean;
}

export const ToastProvider: React.FC = props => {
  const [toastState, setToastState] = useState<ToastState>({
    isPresenting: false,
    message: null,
    isError: false,
  });
  const presentToast = useCallback(
    (message: ToastMessage, isError?: boolean) => {
      const newState = {
        message,
        isPresenting: true,
        isError: isError != null ? isError : false,
      };
      setToastState(newState);
      setTimeout(() => {
        setToastState({
          ...newState,
          isPresenting: false,
        });
      }, TOAST_DURATION);
    },
    [setToastState]
  );
  const value = useMemo(() => {
    return {
      presentToast,
    };
  }, [presentToast]);
  return (
    <ToastContext.Provider value={value}>
      {props.children}
      <Toast {...toastState} />
    </ToastContext.Provider>
  );
};
